import "core-js/modules/es.array.for-each";
import "core-js/modules/es.array.slice";
import "core-js/modules/es.function.name";
import "core-js/modules/web.dom-collections.for-each";
import { __awaiter, __generator } from "tslib";
import Vue from 'vue';
import OrderDetailData from '@/models/orderDetailV2';
export var shopV2Store = {
  namespaced: true,
  state: {
    orderList: {
      list: [],
      req: false,
      loaded: false
    },
    orderDetail: {},
    specMap: {}
  },
  mutations: {
    concatOrderList: function concatOrderList(state, _a) {
      var offset = _a.offset,
          list = _a.list,
          forceUpdate = _a.forceUpdate;

      if (forceUpdate) {
        state.orderList.list = state.orderList.list.slice(0, list.length);
      }

      list.forEach(function (ele, key) {
        Vue.set(state.orderList.list, key + offset, ele);
      });
    },
    setOrderListReq: function setOrderListReq(state, req) {
      state.orderList.req = req;
    },
    setOrderListLoaded: function setOrderListLoaded(state, loaded) {
      state.orderList.loaded = loaded;
    },
    setOrderDetail: function setOrderDetail(state, _a) {
      var detail = _a.detail,
          orderId = _a.orderId;
      Vue.set(state.orderDetail, orderId, detail);
      detail.choices.forEach(function (ele) {
        Vue.set(state.specMap, ele.id, ele);
      });
    }
  },
  actions: {
    /**
     * 获取活动列表
     */
    getOrderList: function getOrderList(context, _a) {
      var offset = _a.offset,
          count = _a.count,
          forceUpdate = _a.forceUpdate;
      return __awaiter(this, void 0, void 0, function () {
        var wrap, response, rdata, list;
        return __generator(this, function (_b) {
          switch (_b.label) {
            case 0:
              wrap = context.state.orderList;

              if (forceUpdate) {
                wrap.req = wrap.loaded = false;
              }

              if (wrap.req || wrap.loaded) {
                return [2
                /*return*/
                ];
              }

              context.commit('setOrderListReq', true);
              return [4
              /*yield*/
              , Vue.axios.get('/api/v2/gift/orders', {
                params: {
                  offset: offset,
                  count: count
                }
              })];

            case 1:
              response = _b.sent();
              rdata = response.data;
              context.commit('setOrderListReq', false);

              if (rdata.status === 0) {
                list = rdata.data;
                context.commit('concatOrderList', {
                  list: list,
                  offset: offset,
                  forceUpdate: forceUpdate
                });

                if (list.length < count) {
                  context.commit('setOrderListLoaded', true);
                }
              }

              return [2
              /*return*/
              , rdata];
          }
        });
      });
    },

    /**
     * 获取订单详情
     */
    getOrderDetail: function getOrderDetail(_a, _b) {
      var commit = _a.commit;
      var orderId = _b.orderId;
      return __awaiter(this, void 0, void 0, function () {
        var response, rdata;
        return __generator(this, function (_c) {
          switch (_c.label) {
            case 0:
              return [4
              /*yield*/
              , Vue.axios.get('/api/v2/gift/order_detail', {
                params: {
                  id: orderId,
                  form_path: location.href
                }
              })];

            case 1:
              response = _c.sent();
              rdata = response.data;

              if (rdata.status === 0) {
                commit('setOrderDetail', {
                  orderId: orderId,
                  detail: new OrderDetailData(rdata.data)
                });
              }

              return [2
              /*return*/
              , rdata];
          }
        });
      });
    },

    /**
     * 获取订单详情
     */
    updateInfo: function updateInfo(_a, _b) {
      var commit = _a.commit;
      var
      /** 订单id */
      id = _b.id,

      /** 收件人 */
      name = _b.name,

      /** 收件人性别 */
      gender = _b.gender,

      /**  收件人年龄 */
      age = _b.age,

      /** 收件人电话 */
      mobile = _b.mobile,
          district = _b.district,

      /** 收件人地址 */
      address = _b.address,

      /** 选择规格id */
      specification = _b.specification;
      return __awaiter(this, void 0, void 0, function () {
        var response, rdata;
        return __generator(this, function (_c) {
          switch (_c.label) {
            case 0:
              return [4
              /*yield*/
              , Vue.axios.post('/api/v2/gift/order', {
                id: id,
                name: name,
                gender: gender,
                age: age,
                mobile: mobile,
                district_1_id: district === null || district === void 0 ? void 0 : district[0],
                district_2_id: district === null || district === void 0 ? void 0 : district[1],
                district_3_id: district === null || district === void 0 ? void 0 : district[2],
                address: address,
                specification: specification
              })];

            case 1:
              response = _c.sent();
              rdata = response.data;
              return [2
              /*return*/
              , rdata];
          }
        });
      });
    }
  }
};